import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Earth, NotepadText, Pin,Calendar } from "lucide-react";
import { useUserSelection } from "../../../../../store/UserPayment";
import getToken from "../../../../../hooks/getToken";

import Riyal from "../../../../ui/riyal";
import TrCourseImg from "../../../../../assets/images/TrainingCoursesImg.png";

const OfferBox = ({ offer }) => {
    const { t } = useTranslation();

    const { setRowDetails, setSelectedPayment } = useUserSelection();
    const { price_before_discount, price, course, category, city,subject} = offer;

    const navigate = useNavigate();
    const token = getToken();



    const { id } = useParams();

    // Calculate days between two dates
    const calculateDuration = (startDate, endDate) => {
        if (!startDate || !endDate) return '';
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays.toString();
    };

    const handleOfferClick = () => {
        const duration = calculateDuration(offer?.start_date, offer?.end_date);

        // Set the selected payment details
        setSelectedPayment({
            location: city?.title || '',
            currencyTitle: 'SAR',
            startDate: offer?.start_date || '',
            endDate: offer?.end_date || '',
            duration: duration,
            payment: '',
            paymentInAr: ''
        });

        // Set row details for offer
        setRowDetails({
            courseId: course?.id || '',
            courseOfferId: id || '',
            courseOfferPrice: price || '',
            thisRowPrice: price_before_discount || price || '',  // Add thisRowPrice
            discount: offer?.discount || '',
            city: city || {},
            start_date: offer?.start_date || '',
            end_date: offer?.end_date || '',
            duration: duration
        });
    };

    return (
        <Link 
            to={`/training-courses/${course?.id}?ref=offer-${id}&start_date=${offer?.start_date}&end_date=${offer?.end_date}`}
            className=""
            onClick={handleOfferClick}>
            <div className='relative  offer-box-link group pt-7 pb-3 px-3 flex flex-col lg:grid lg:grid-cols-[22%_77%] border rounded-lg w-full mb-5 mt-5'
          >
                <div className='relative w-32 bg-transparent max-lg:h-4 max-md:w-full'>
                    <div className='w-[7.5rem] h-[7.5rem] flex justify-center items-center absolute -top-14 inset-y-0 end-16 max-lg:end-5 max-md:end-0 max-lg:h-28 max-lg:w-full max-lg:relative'>
                        <div className='bg-secondary-tw w-[7.8rem] h-[7.8rem] max-lg:h-[7.4rem] max-lg:w-[12.4rem] max-md:w-full absolute z-0 rounded-lg'></div>
                        <img src={course?.image || TrCourseImg} alt='course-title' className='object-cover w-full relative z-10 h-full rounded-lg' />
                        <div className="absolute -bottom-8 z-20 bg-secondary-tw rounded-md text-white px-2">
                            <p className="m-0">{offer?.discount}%</p>
                            <p className="m-0">{t('training-courses.discount')}</p>
                        </div>
                    </div>
                </div>
                <div className='flex flex-col justify-between gap-4 max-lg:mt-24'>
                    <div className='!text-start space-y-1'>
                        {course?.title &&

                            <p className='text-primary-tw text-md !text-start max-w-96'
                            style={{paddingRight: '1rem'}}>
                                {course?.title}
                            </p>
                        }
                        {
                            category?.title &&
                            <div className='flex items-center gap-2'>
                                <span>
                                    <Pin fill='#7A7A7A' size={16} color='#7A7A7A' />
                                </span>
                                <p className='text-semi-gray text-sm truncate m-0'>
                                    {category?.title}
                                </p>
                            </div>
                        }
                        {
                            subject?.title &&
                            <div className='flex items-center gap-2'>
                                <span>
                                    <NotepadText fill='white' size={16} color='#7A7A7A' />
                                </span>
                                <p className='text-semi-gray text-sm  m-0'
                               >
                                    {subject?.title}
                                </p>
                            </div>
                        }
                        {
                            city?.title &&
                            <div className='flex items-center gap-2'>
                                <span>
                                    <Earth size={16} color='#7A7A7A' />
                                </span>
                                <p className='text-semi-gray text-sm truncate m-0'>
                                    {city?.title}
                                </p>
                            </div>
                        }
                        <div className='space-y-2'>
                            <div className='flex items-center gap-2'>
                                <span>
                                    <Calendar size={16} color='#7A7A7A' />
                                </span>
                                <div className='text-semi-gray text-sm'>
                                   
                                    <div>
                                        {/* <span className='text-primary-tw'>{t('custom.course-period')}:</span> */}
                                        <div className='mt-1'>
                                        <span className="mx-1">{t('من')}</span> <span> {offer?.start_date}</span>   <span className="mx-1">{t('الى')}</span> <span>{offer?.end_date}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex items-center gap-2 mt-2 flex-wrap justify-content-center max-lg:items-start'>
                        <p className='text-semi-gray text-sm'>
                            {t('profile.price')} :
                        </p>
                        <p className=' bg-primary-tw text-sm flex items-center gap-1 text-white px-3 rounded-md py-[1px]'>
                            <span>
                                {price || "0"} {t('custom.instead')} <del>{price_before_discount || "0"}</del>
                            </span>
                            <span>
                                <Riyal />
                            </span>
                        </p>

                        {/* <div className="text-semi-gray text-sm w-100">
                        <span className='text-semi-gray text-sm m-2'>
                            {t('profile.time-period')}: 
                        </span>
                        <span className="mx-1">{t('من')}</span> <span> {offer?.parent_offer_start_date}</span> <span className="mx-1">{t('الى')}</span> <span>{offer?.parent_offer_end_date}</span>

                   </div> */}
                    </div>

                  
                </div>

                      
                       
                 
                <div className="flex items-end justify-end gap-2  w-full col-span-2 flex-wrap">
                  
                    <button className="bg-secondary-tw text-white px-4 py-1 rounded-lg">
                        {t('custom.more-details')}
                    </button>
                    <button 
                        className="bg-primary-tw text-white px-4 py-1 rounded-lg"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleOfferClick();
                            navigate(`/offers/${id}/payment/way?ref=offer-${id}`);
                        }}
                    >
                       {t("custom.register")} 
                    </button>
                </div>
            </div>
        </Link>
    );
};

export default React.memo(OfferBox);
